import { useCommissionAccess } from "@/hooks/useCommissionAccess";
import { TeamTree } from "./components/team-tree";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAppStore } from "@/stores";
import { useLocation } from "wouter";
import useSWR from "swr";
import { TableType, getAll } from "@/lib/supabase";
import { Loader } from "@/components/Loader";
import { getRoute } from "@/lib/routes";
import { ErrorWithRetry } from "@/components/ErrorWithRetry";

export function TeamsPage() {
  const { data: access, error: accessError, isLoading: accessLoading } = useCommissionAccess();
  const appState = useAppStore((state) => state);
  const { currentUser } = appState;

  const {
    data: teams,
    error,
    isLoading,
  } = useSWR(
    [
      "teams" as TableType,
      currentUser ? currentUser?.company_id.toString() : null,
    ],
    ([table, companyId]) => getAll(table, companyId),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
  const [, setLocation] = useLocation();


  if (error || accessError) {
    return (
      <ErrorWithRetry
        error={accessError?.message || error?.message || "Could not load teams"}
        onRetry={() => window.location.reload()}
      />
    );
  }

  if (isLoading || accessLoading || !teams || !access) return <Loader />;

  return (
    <main className="flex-1 sm:py-0">
      <Card x-chunk="dashboard-05-chunk-3" className="border-transparent">
        <div className="flex flex-row justify-between items-center pt-3 pb-8">
          <CardHeader className="flex p-0">
            <CardTitle>
              <h1>Teams</h1>
            </CardTitle>
          </CardHeader>
          <Button
            onClick={() => setLocation(getRoute("teams", "team", "new"))}
          >
            Add new team
          </Button>
        </div>
        <CardContent className="px-0">
          {teams && teams.length > 0 ? (
            <TeamTree teams={access?.teams ?? []} onSelect={id => setLocation(getRoute("teams", "team", String(id)))} />
          ) : (
            <div className="text-lg text-muted-foreground text-center flex flex-col justify-center h-[400px]">
              Add your first team to start rewarding performance 🚀
            </div>
          )}
        </CardContent>
      </Card>
    </main>
  );
}
